import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProfile } from 'src/hooks/useAuthProfile';

export function RequireAdmin({ children }: PropsWithChildren<{}>) {
  const location = useLocation();
  const { profile, loading } = useAuthProfile();

  if (loading) {
    return <div style={{ padding: 32 }}>Carregando permissões...</div>;
  }

  const role = (profile?.role ?? '').toLowerCase();

  if (role !== 'admin') {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

